import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Error from '../../../assets/Error.svg';
import { CONTACT_SUPPORT_HREF } from '../../constants/text';
import './NotValidBanner.css';

export const NotValidBanner = ({ onClose }) => {
  const [showBanner, setShowBanner] = useState(true);

  const onClick = () => {
    onClose();
    setShowBanner(false);
  };

  return showBanner && (
    <div className="custom-alert">
      <div className="custom-alert-text">
        <img alt="" src={Error} />
        <strong>
          {'Registration request not valid. Please try again, or '}
          <a href={CONTACT_SUPPORT_HREF}>contact support</a>
          .
        </strong>
      </div>
      <button className="custom-alert-close" type="button" onClick={onClick}>
        <span>×</span>
      </button>
    </div>
  );
};

NotValidBanner.propTypes = {
  onClose: PropTypes.func,
};

NotValidBanner.defaultProps = {
  onClose: () => {},
};
